<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <radio-field
                    :label="$t('forms.intake.about_you.fields.completion_method.label')"
                    :options="completionMethodOptions"
                    :isRequired="true"
                    :formData="data"
                    valuePath="completionMethod"
                    direction="column"
                    @change="change($event)"
                ></radio-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <radio-field
                    :label="$t('forms.intake.about_you.fields.information_provider.label')"
                    :options="informationProviderOptions"
                    :isRequired="true"
                    :formData="data"
                    valuePath="informationProvider"
                    direction="column"
                    @change="change($event)"
                ></radio-field>
            </form-cell>
        </form-row>

        <intake-form-section class="about-you__contact" :title="$t('forms.intake.about_you.sections.contact')">
            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.about_you.fields.full_name.label')"
                        :placeholder="$t('forms.intake.about_you.fields.full_name.placeholder')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="fullName"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell width="half">
                    <birth-date-field
                        :label="$t('forms.intake.about_you.fields.date_of_birth.label')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="dateOfBirth"
                        @change="change($event)"
                    ></birth-date-field>
                </form-cell>
                <form-cell width="half">
                    <phone-field
                        :label="$t('forms.intake.about_you.fields.phone.label')"
                        :placeholder="$t('forms.intake.about_you.fields.phone.placeholder')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="phone"
                        @change="change($event)"
                    ></phone-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.about_you.fields.email.label')"
                        :placeholder="$t('forms.intake.about_you.fields.email.placeholder')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="email"
                        type="email"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    :isDisabled="true"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            return {
                data: {
                    completionMethod: 'online',
                    informationProvider: 'patient',
                    fullName: undefined,
                    dateOfBirth: undefined,
                    phone: undefined,
                    email: undefined,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            completionMethodOptions() {
                return [
                    {
                        label: this.$t('forms.intake.about_you.fields.completion_method.options.online'),
                        value: 'online',
                    },
                    {
                        label: this.$t('forms.intake.about_you.fields.completion_method.options.phone_interview'),
                        value: 'phone_interview',
                    },
                ]
            },

            informationProviderOptions() {
                return [
                    {
                        label: this.$t('forms.intake.about_you.fields.information_provider.options.patient'),
                        value: 'patient',
                    },
                    {
                        label: this.$t('forms.intake.about_you.fields.information_provider.options.parent'),
                        value: 'parent',
                    },
                    {
                        label: this.$t('forms.intake.about_you.fields.information_provider.options.caregiver'),
                        value: 'caregiver',
                    },
                    {
                        label: this.$t('forms.intake.about_you.fields.information_provider.options.other'),
                        value: 'other',
                    },
                ]
            },
        },

        methods: {
            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';

    .about-you__contact {
        margin-top: rem(32px);
    }
</style>
